import React from "react";
import { useFormikContext } from "formik";
import FormField from "../../../utils/FormFileds";
import { Box, Typography } from "@mui/material";

const Step1 = ({ fields }) => {
  const { errors, touched } = useFormikContext();
  return (
    <div className="border md:px-16 px-2 md:py-8 py-2 rounded-xl">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          justifyContent: "center",
          alignItems: "center",
          // paddingY: { md: 3, xs: 2 },
          marginBottom: 2,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            color: "#242424",
            lineHeight: "30px",
            textAlign: "left",
          }}
        >
          Ready to Get Paid?
        </Typography>

        <Typography
          sx={{
            color: "#595959",
            fontSize: { md: "20px", xs: "16px" },
            textAlign: "center",
            // lineHeight: "24px",
            my: 1,
          }}
          variant="h3"
        >
          Let’s confirm some information first.
        </Typography>
      </Box>

      <div className="grid md:grid-cols-2 justify-center   md:gap-4 gap-2 w-full">
        {Object.values(fields).map((field) => (
          <FormField
            key={field.name}
            {...field}
            error={errors[field.name]}
            touched={touched[field.name]}
          />
        ))}
      </div>
    </div>
  );
};

export default Step1;
